/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ApiClientPage = {
  Home: 'home',
  HomeFlex: 'home_flex',
  Account: 'account',
  PetProfileView: 'pet_profile_view',
  Typ: 'typ',
} as const;
export type ApiClientPage = typeof ApiClientPage[keyof typeof ApiClientPage];

export function ApiClientPageFromJSON(json: any): ApiClientPage {
  return ApiClientPageFromJSONTyped(json, false);
}

export function ApiClientPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiClientPage {
  return json as ApiClientPage;
}

export function ApiClientPageToJSON(value?: ApiClientPage | null): any {
  return value as any;
}
